<template>
  <div class="main col-md-12 animate__animated animate__fadeIn animate__faster">
    <div
      v-if="loading"  
      class="col-md-12 text-center mt-5">
      <Spinner class="text-light"/>
    </div>
    <div
      v-else  
      class="p-3"
      style="border-radius: 10px;">
      <!-- Sort Options -->
      <div class="float-end">
        Sort By
        <select
          class="form-select"
          style="max-width: 250px;"
          v-model="sort">
          <option value="id-asc">ID Ascending</option>
          <option value="id-desc">ID Descending</option>
          <option
            v-if="dateSort"
            value="start-date-asc">Start Date Ascending
          </option>
          <option
            v-if="dateSort"
            value="start-date-desc">Start Date Descending
          </option>
          <option
            v-if="dateSort"
            value="end-date-asc">End Date Ascending
          </option>
          <option
            v-if="dateSort"
            value="end-date-desc">End Date Descending
          </option>
        </select>
      </div>
      <div class="clearfix"/>
      <div
        v-if="!activeRecord"
        class="mb-3 px-5 text-center">
        <p v-if="data && data.options">{{data.options.description}}</p>
      </div>
      <Index
        v-if="activeRecord == null && !createNew && !activePromo"
        class="animate__animated animate__fadeIn animate__faster"
        :data="sortedData"
        :view="view"
        :todaysDate="todaysDate"
        @toggleCreateNew="toggleCreateNew"/>
      <Detail
        v-if="(activeRecord || createNew) && !activePromo"
        class="animate__animated animate__fadeIn animate__faster"
        :data="sortedData"
        :view="view"
        :activeRecord="activeRecord"
        @cancelCreateNew="cancelCreateNew"/>
      <PromoData v-if="activePromo"/>
      </div>
    </div>
</template>

<script>
  import Index from './Index.vue'
  import Detail from  './Detail.vue'
  import Spinner from '../../../global/Spinner.vue'
  import PromoData from './promos/PromoData.vue'
  import moment from 'moment'

  export default {
    props: ['data', 'view'],
    data(){
      return{
        createNew: false,
        sort: 'id-asc'
      }
    },
    watch:{
      view(newVal, oldVal){
        if(newVal != oldVal){
          this.cancelCreateNew()
        }
      }
    },
    components:{
      Index,
      Detail,
      Spinner,
      PromoData
    },
    methods:{
      toggleCreateNew(){
        this.createNew = !this.createNew
      },
      cancelCreateNew(){
        this.createNew = false
      }
    },
    computed:{
      activeRecord(){return this.$store.getters.adminActiveRecord},
      activePromo(){return this.$store.getters.adminActivePromo},
      loading(){return this.$store.getters.adminLoading},
      sortedData(){
        switch(this.sort){
          case 'id-asc':
            this.data.table_values = _.orderBy(this.data.table_values, ['id'], ['asc'])
            break
          case 'id-desc':
            this.data.table_values = _.orderBy(this.data.table_values, ['id'], ['desc'])
            break
          case 'start-date-asc':
            this.data.table_values = _.orderBy(this.data.table_values, ['start_date'], ['asc'])
            break
          case 'start-date-desc':
            this.data.table_values = _.orderBy(this.data.table_values, ['start_date'], ['desc'])
            break
          case 'end-date-asc':
            this.data.table_values = _.orderBy(this.data.table_values, ['end_date'], ['asc'])
            break
          case 'end-date-desc':
            this.data.table_values = _.orderBy(this.data.table_values, ['end_date'], ['desc'])
            break
        }
        return this.data
      },
      todaysDate(){return moment()},
      dateSort(){
        const base = _.map(this.data.table_data, 'column')
        return base.includes('start_date') && base.includes('end_date') && this.view == 'promos'
      }
    }
  }
</script>

<style scoped>
  .main{
    overflow: hidden;
  }
</style>